import {
  Digitalizados,
  DigitalizadosCreateForm,
  DigitalizadosTrash
} from "./digitalizados"
import {
  AditivosEditForm,
  AditivosCreateForm,
  Aditivos,
  AditivosTrash
} from "./aditivos"
export { default as Contratos } from "./Contratos"
export { default as ContratosEditForm } from "./ContratosEditForm"
export { default as ContratosCreateForm } from "./ContratosCreateForm"
export { default as TableContratos } from "./TableContratos"
export { default as ContratosManageForm } from "./ContratosManageForm"
export { default as TableNavContratos } from "./TableNavContratos"
export { default as TableContratosTrash } from "./TableContratosTrash"
export { default as ContratosTrash } from "./ContratosTrash"
export { Digitalizados, DigitalizadosCreateForm, DigitalizadosTrash }
export { AditivosEditForm, AditivosCreateForm, Aditivos, AditivosTrash }



// WEBPACK FOOTER //
// ./src/views/contratos/index.js